import React, { useState, useEffect } from 'react';
import { actualizarAlerta } from '../lib/db';
import { supabase } from '../lib/supabase';

const alertasIniciales = [];

const tiposAlertaIniciales = [
  { id: 0, key: 'sin_actualizacion', label: 'Sin actualización', color: '#f59e0b', activo: true },
  { id: 1, key: 'detencion', label: 'Detención prolongada', color: '#f59e0b', activo: true },
  { id: 2, key: 'velocidad', label: 'Velocidad excesiva', color: '#ef4444', activo: true },
  { id: 3, key: 'desvio', label: 'Desviación de ruta', color: '#8b5cf6', activo: true },
  { id: 4, key: 'hito', label: 'Hito no confirmado', color: '#3b82f6', activo: true },
  { id: 5, key: 'llegada', label: 'Llegada próxima', color: '#00e5a0', activo: true },
];

const motivosDetencion = ['Tráfico', 'Descanso / Comida', 'Parada técnica', 'En carga / descarga', 'Otro'];

export default function Alertas({ alerts: alertasProp, setAlerts: setAlertasProp, minutosAlerta = 60, setMinutosAlerta }) {
  const [alertas, setAlertasLocal] = useState([]);
useEffect(() => { setAlertasLocal(alertasProp || []); }, [alertasProp]);
  const [tiposAlerta, setTiposAlerta] = useState(tiposAlertaIniciales);
  const [filtroEstado, setFiltroEstado] = useState('todas');
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [configTiempo, setConfigTiempo] = useState(minutosAlerta);
  const [configVelocidad, setConfigVelocidad] = useState(110);
  const [editandoConfig, setEditandoConfig] = useState(false);
  const [editandoAlerta, setEditandoAlerta] = useState(null);
  const [editandoTipo, setEditandoTipo] = useState(null);
  const [showNuevoTipo, setShowNuevoTipo] = useState(false);
  const [nuevoTipo, setNuevoTipo] = useState({ label: '', icon: '🔔', color: '#00e5a0' });

  const setAlertas = (val) => {
    setAlertasLocal(val);
    if (setAlertasProp) setAlertasProp(val);
  };

  const dismiss = async (id, motivo) => {
    await actualizarAlerta(id, { dismissed: true, motivo });
    setAlertas(alertas.map(a => a.id === id ? { ...a, dismissed: true, motivo } : a));
  };
  const reactivar = async (id) => {
    await actualizarAlerta(id, { dismissed: false, motivo: '' });
    setAlertas(alertas.map(a => a.id === id ? { ...a, dismissed: false, motivo: '' } : a));
  };
  const eliminarAlerta = async (id) => {
    await supabase.from('alertas').delete().eq('id', id);
    setAlertas(alertas.filter(a => a.id !== id));
  };
  const guardarEdicionAlerta = (id, datos) => { setAlertas(alertas.map(a => a.id === id ? { ...a, ...datos } : a)); setEditandoAlerta(null); };
  const toggleTipo = (id) => setTiposAlerta(tiposAlerta.map(t => t.id === id ? { ...t, activo: !t.activo } : t));
  const eliminarTipo = (id) => setTiposAlerta(tiposAlerta.filter(t => t.id !== id));
  const guardarEdicionTipo = (id, datos) => { setTiposAlerta(tiposAlerta.map(t => t.id === id ? { ...t, ...datos } : t)); setEditandoTipo(null); };
  const agregarTipo = () => {
    if (!nuevoTipo.label) return;
    setTiposAlerta([...tiposAlerta, { id: Date.now(), key: nuevoTipo.label.toLowerCase().replace(/ /g, '_'), ...nuevoTipo, activo: true }]);
    setNuevoTipo({ label: '', icon: '🔔', color: '#00e5a0' });
    setShowNuevoTipo(false);
  };

  const tipoConfig = Object.fromEntries(tiposAlerta.map(t => [t.key, t]));
  const alertasFiltradas = alertas.filter(a => {
    if (filtroEstado === 'todas' && a.dismissed) return false;
    const estadoOk = filtroEstado === 'todas' || (filtroEstado === 'activas' && !a.dismissed) || (filtroEstado === 'desactivadas' && a.dismissed);
    const tipoOk = filtroTipo === 'todos' || a.tipo === filtroTipo;
    return estadoOk && tipoOk;
  });
  const activas = alertas.filter(a => !a.dismissed).length;
  const desactivadas = alertas.filter(a => a.dismissed).length;

  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff' }}>ALERTAS</h1>
        <button onClick={() => setEditandoConfig(!editandoConfig)}
          style={{ background: editandoConfig ? '#00e5a0' : 'transparent', color: editandoConfig ? '#000' : '#6b7280', border: '1px solid #222730', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
          Configurar umbrales
        </button>
      </div>

      {editandoConfig && (
        <div style={{ background: '#111318', border: '1px solid #00e5a0', borderRadius: '10px', padding: '20px', marginBottom: '24px' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '16px', color: '#00e5a0' }}>Configuración de Umbrales</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '20px' }}>
            <div>
              <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Tiempo de detención para alerta (minutos)</label>
              <input type="number" value={configTiempo} onChange={e => setConfigTiempo(e.target.value)}
                style={{ background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '14px', width: '100%' }} />
              <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Default: 30 minutos</div>
            </div>
            <div>
              <label style={{ fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' }}>Límite de velocidad para alerta (km/h)</label>
              <input type="number" value={configVelocidad} onChange={e => setConfigVelocidad(e.target.value)}
                style={{ background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '14px', width: '100%' }} />
              <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Default: 110 km/h</div>
            </div>
          </div>
          <div style={{ borderTop: '1px solid #222730', paddingTop: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#e8eaf0' }}>Tipos de alerta</div>
              <button onClick={() => setShowNuevoTipo(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>+ Agregar tipo</button>
            </div>
            {showNuevoTipo && (
              <div style={{ background: '#181c24', border: '1px solid #222730', borderRadius: '8px', padding: '14px', marginBottom: '12px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 120px', gap: '10px', marginBottom: '10px' }}>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Nombre</label>
                    <input value={nuevoTipo.label} onChange={e => setNuevoTipo({ ...nuevoTipo, label: e.target.value })}
                      placeholder="Ej: Temperatura alta" style={{ width: '100%', background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Ícono</label>
                    <input value={nuevoTipo.icon} onChange={e => setNuevoTipo({ ...nuevoTipo, icon: e.target.value })}
                      style={{ width: '100%', background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '16px', textAlign: 'center' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Color</label>
                    <input type="color" value={nuevoTipo.color} onChange={e => setNuevoTipo({ ...nuevoTipo, color: e.target.value })}
                      style={{ width: '100%', background: '#111318', border: '1px solid #222730', borderRadius: '6px', padding: '4px', height: '36px', cursor: 'pointer' }} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={agregarTipo} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Agregar</button>
                  <button onClick={() => setShowNuevoTipo(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            )}
            {tiposAlerta.map(t => (
              <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0', borderBottom: '1px solid #222730' }}>
                {editandoTipo === t.id ? (
                  <div style={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                    <input defaultValue={t.icon} id={`icon-${t.id}`} style={{ width: '50px', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '6px', color: '#e8eaf0', fontSize: '16px', textAlign: 'center' }} />
                    <input defaultValue={t.label} id={`label-${t.id}`} style={{ flex: 1, background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '6px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                    <button onClick={() => guardarEdicionTipo(t.id, { icon: document.getElementById(`icon-${t.id}`).value, label: document.getElementById(`label-${t.id}`).value })}
                      style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Guardar</button>
                    <button onClick={() => setEditandoTipo(null)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 10px', fontSize: '12px', cursor: 'pointer' }}>✕</button>
                  </div>
                ) : (
                  <>
                    <span style={{ fontSize: '18px' }}>{t.icon}</span>
                    <span style={{ flex: 1, fontSize: '13px', color: t.activo ? '#e8eaf0' : '#6b7280' }}>{t.label}</span>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <button onClick={() => setEditandoTipo(t.id)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}>Editar</button>
                      <div onClick={() => toggleTipo(t.id)} style={{ width: '36px', height: '20px', borderRadius: '10px', background: t.activo ? '#00e5a0' : '#222730', cursor: 'pointer', position: 'relative', flexShrink: 0 }}>
                        <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: t.activo ? '19px' : '3px', transition: 'left 0.2s' }}></div>
                      </div>
                      <button onClick={() => eliminarTipo(t.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '12px' }}>Eliminar</button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          <button onClick={() => { if (setMinutosAlerta) setMinutosAlerta(Number(configTiempo)); setEditandoConfig(false); }}
            style={{ marginTop: '16px', background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 20px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
            Guardar configuración
          </button>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {[
          { label: 'Alertas Activas', value: activas, color: '#f59e0b' },
          { label: 'Desactivadas Hoy', value: desactivadas, color: '#00e5a0' },
          { label: 'Tiempo detención (umbral)', value: `${configTiempo} min`, color: '#3b82f6' },
          { label: 'Vel. máxima (umbral)', value: `${configVelocidad} km/h`, color: '#8b5cf6' },
        ].map((k, i) => (
          <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${k.color}` }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', marginBottom: '10px' }}>{k.label}</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: k.color, lineHeight: 1 }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {['todas', 'activas', 'desactivadas'].map(f => (
          <button key={f} onClick={() => setFiltroEstado(f)}
            style={{ padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: `1px solid ${filtroEstado === f ? '#00e5a0' : '#222730'}`, color: filtroEstado === f ? '#00e5a0' : '#6b7280', background: filtroEstado === f ? 'rgba(0,229,160,0.06)' : '#111318' }}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
        <div style={{ width: '1px', background: '#222730', margin: '0 4px' }}></div>
        <button onClick={() => setFiltroTipo('todos')}
          style={{ padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: `1px solid ${filtroTipo === 'todos' ? '#3b82f6' : '#222730'}`, color: filtroTipo === 'todos' ? '#3b82f6' : '#6b7280', background: filtroTipo === 'todos' ? 'rgba(59,130,246,0.06)' : '#111318' }}>
          Todos los tipos
        </button>
        {tiposAlerta.map(t => (
          <button key={t.key} onClick={() => setFiltroTipo(t.key)}
            style={{ padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: `1px solid ${filtroTipo === t.key ? '#3b82f6' : '#222730'}`, color: filtroTipo === t.key ? '#3b82f6' : '#6b7280', background: filtroTipo === t.key ? 'rgba(59,130,246,0.06)' : '#111318' }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Historial de Alertas</span>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>{alertasFiltradas.length} resultados</span>
        </div>
        {alertasFiltradas.length === 0 && (
          <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Sin alertas para los filtros seleccionados</div>
        )}
        {alertasFiltradas.map(a => (
          <div key={a.id} style={{ padding: '16px 20px', borderBottom: '1px solid #222730', opacity: a.dismissed ? 0.7 : 1 }}>
            {editandoAlerta === a.id ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Unidad</label>
                    <input defaultValue={a.unidad} id={`unidad-${a.id}`} style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Conductor</label>
                    <input defaultValue={a.conductor} id={`conductor-${a.id}`} style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Ubicación</label>
                    <input defaultValue={a.loc} id={`loc-${a.id}`} style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Tipo</label>
                    <select defaultValue={a.tipo} id={`tipo-${a.id}`} style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' }}>
                      {tiposAlerta.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => guardarEdicionAlerta(a.id, {
                    unidad: document.getElementById(`unidad-${a.id}`).value,
                    conductor: document.getElementById(`conductor-${a.id}`).value,
                    loc: document.getElementById(`loc-${a.id}`).value,
                    tipo: document.getElementById(`tipo-${a.id}`).value,
                  })} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Guardar</button>
                  <button onClick={() => setEditandoAlerta(null)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                    <span style={{ fontFamily: 'monospace', fontSize: '13px', fontWeight: '700', color: tipoConfig[a.tipo]?.color || '#6b7280' }}>{a.viaje_numero || a.unidad}</span>
                    <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: `${tipoConfig[a.tipo]?.color || '#6b7280'}18`, color: tipoConfig[a.tipo]?.color || '#6b7280' }}>{tipoConfig[a.tipo]?.label || a.tipo}</span>
                    <span style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace', marginLeft: 'auto' }}>{a.hora}</span>
                  </div>
                  <div style={{ fontSize: '13px', marginBottom: '6px', color: '#e8eaf0' }}>
                    <span style={{ color: '#6b7280', fontSize: '11px' }}>Unidad </span>{a.unidad}
                    {a.caja ? <><span style={{ color: '#6b7280' }}> · </span><span style={{ color: '#6b7280', fontSize: '11px' }}>Caja </span>{a.caja}</> : ''}
                    <span style={{ color: '#6b7280' }}> · </span>{a.loc}
                  </div>
                  {a.mins > 0 && <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>{a.mins} minutos detenida</div>}
                  {!a.dismissed ? (
                    <div>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px' }}>Desactivar por:</div>
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {motivosDetencion.map(m => (
                          <button key={m} onClick={() => dismiss(a.id, m)}
                            style={{ fontSize: '11px', padding: '4px 12px', borderRadius: '4px', border: 'none', background: 'rgba(245,158,11,0.15)', color: '#f59e0b', cursor: 'pointer', fontWeight: '600' }}>
                            {m}
                          </button>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ fontSize: '11px', color: '#00e5a0' }}>✓ Desactivada · Motivo: {a.motivo}</div>
                      <button onClick={() => reactivar(a.id)} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '4px', border: '1px solid #f59e0b', background: 'transparent', color: '#f59e0b', cursor: 'pointer', fontWeight: '600' }}>↺ Reactivar</button>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                  <button onClick={() => setEditandoAlerta(a.id)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '5px 8px', fontSize: '12px', cursor: 'pointer' }}>Editar</button>
                  <button onClick={() => eliminarAlerta(a.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '12px' }}>Eliminar</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}